import { createFileRoute } from '@tanstack/react-router';
import { SystemDevicesList } from '@/features/realtime/components/SystemDevicesList';

export const Route = createFileRoute('/system/devices')({
  component: SystemDevicesList,
});
